// import React, { useState, useMemo, useEffect, useRef } from 'react';
// import { PageTitle, Button, Card } from '../components/common';
// import { Project, Feature, Task, TaskStatus, TaskPriority } from '../types';
// import { useToast } from '../components/Toaster';
// import { 
//   getTraineeProjectsByToken, 
//   getTraineeProjectFeatures, 
//   addProjectTask, 
//   updateTraineeTaskStatus,
//   getTraineeFeatureTasks 
// } from '../services/api';

// // Icons (keep all your existing icons)

// const PlusIcon: React.FC<{className?: string}> = ({className = "w-4 h-4"}) => (
//   <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//   </svg>
// );

// const CalendarIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 text-gray-500"}) => (
//   <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//   </svg>
// );

// const XIcon: React.FC<{className?: string}> = ({className = "w-5 h-5"}) => (
//   <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//   </svg>
// );

// const ChevronDownIcon: React.FC<{className?: string}> = ({className = ""}) => (
//   <svg xmlns="http://www.w3.org/2000/svg" className={`w-5 h-5 transition-transform ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//   </svg>
// );

// const TrashIcon: React.FC<{className?: string}> = ({className = "h-4 w-4"}) => (
//   <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//   </svg>
// );

// const SearchIcon: React.FC<{className?: string}> = ({className = "w-5 h-5 text-gray-400"}) => (
//   <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//   </svg>
// );

// const FilterIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 mr-1.5"}) => (
//   <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
//   </svg>
// );

// const SortIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 mr-1.5"}) => (
//   <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9M3 12h9m-9 4h13m-3-3l-3 3m0 0l-3-3m3 3V4" />
//   </svg>
// );

// const columns: TaskStatus[] = ['To Do', 'In Progress', 'In Review', 'Done'];
// const priorities: TaskPriority[] = ['High', 'Medium', 'Low'];
// const columnColors: Record<TaskStatus, string> = {
//     'To Do': 'border-t-gray-400',
//     'In Progress': 'border-t-orange-400',
//     'In Review': 'border-t-purple-500',
//     'Done': 'border-t-green-500',
// };
// const columnHeaderColors: Record<TaskStatus, string> = {
//     'To Do': 'text-gray-700',
//     'In Progress': 'text-orange-700',
//     'In Review': 'text-purple-700',
//     'Done': 'text-green-700',
// };

// // Helper function to map API status names to our TaskStatus
// const mapApiStatusToTaskStatus = (statusName: string): TaskStatus => {
//     const statusMap: Record<string, TaskStatus> = {
//         'TO DO': 'To Do',
//         'IN PROGRESS': 'In Progress',
//         'IN REVIEW': 'In Review',
//         'DONE': 'Done',
//         'To Do': 'To Do',
//         'In Progress': 'In Progress',
//         'In Review': 'In Review',
//         'Done': 'Done'
//     };
//     return statusMap[statusName] || 'To Do';
// };

// // Helper function to map our TaskStatus to API status codes
// const mapTaskStatusToApiCode = (status: TaskStatus): string => {
//     const statusMap: Record<TaskStatus, string> = {
//         'To Do': 'TOD123',
//         'In Progress': 'INP123',
//         'In Review': 'INR123',
//         'Done': 'DON123'
//     };
//     return statusMap[status] || 'TOD123';
// };

// interface PriorityBadgeProps {
//     priority: TaskPriority;
// }

// const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
//     const styles = {
//         High: 'bg-red-100 text-red-700',
//         Medium: 'bg-yellow-100 text-yellow-800',
//         Low: 'bg-blue-100 text-blue-800',
//     };
//     return (
//         <span className={`inline-block px-2 py-0.5 text-xs font-semibold rounded-full ${styles[priority]}`}>
//             {priority}
//         </span>
//     );
// };

// interface StatusTagProps {
//     status: TaskStatus;
// }

// const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
//     const styles: Record<TaskStatus, string> = {
//         'To Do': 'bg-gray-200 text-gray-800',
//         'In Progress': 'bg-orange-200 text-orange-800',
//         'In Review': 'bg-purple-200 text-purple-800',
//         'Done': 'bg-green-200 text-green-800',
//     };
//     return (
//         <span className={`px-2 py-1 text-xs font-medium rounded ${styles[status]}`}>
//             {status}
//         </span>
//     );
// };

// interface TaskCardComponentProps {
//     task: Task; 
//     onDragStart: (e: React.DragEvent<HTMLDivElement>, taskId: string) => void;
//     onClick: () => void;
// }

// const TaskCardComponent: React.FC<TaskCardComponentProps> = ({ task, onDragStart, onClick }) => {
//     const formatDate = (dateString?: string) => {
//         if (!dateString) return null;
//         const date = new Date(dateString);
//         const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
//         return adjustedDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//     }

//     return (
//         <div 
//             draggable
//             onDragStart={(e) => onDragStart(e, task.id)}
//             onClick={onClick}
//             className="bg-white p-3 mb-2 rounded-lg border border-gray-200 shadow-sm hover:shadow-md hover:border-primary transition-all duration-200 cursor-pointer group"
//         >
//             <div className="flex justify-between items-start">
//                 <div className="flex-1">
//                     <p className="font-semibold text-sm text-gray-800 group-hover:text-primary">{task.title}</p>
//                     <div className="flex items-center justify-between gap-2 mt-2">
//                         <StatusTag status={task.status} />
//                         {formatDate(task.dueDate) && (
//                             <div className="flex items-center text-xs text-gray-500">
//                                 <CalendarIcon />
//                                 <span className="ml-1">{formatDate(task.dueDate)}</span>
//                             </div>
//                         )}
//                     </div>
//                     <div className="flex justify-start items-center mt-3">
//                         <PriorityBadge priority={task.priority} />
//                     </div>
//                     <div className="flex items-center gap-2 mt-2">
//                         <img 
//                             src={task.assignee.avatar} 
//                             alt={task.assignee.name}
//                             className="w-6 h-6 rounded-full"
//                         />
//                         <span className="text-xs text-gray-600">{task.assignee.name}</span>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// interface TaskModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     onSave: (task: Task, featureId: string) => void;
//     onDelete: (taskId: string) => void;
//     task: Task | null;
//     featureId: string;
//     initialStatus: TaskStatus;
// }

// const TaskModal: React.FC<TaskModalProps> = ({ isOpen, onClose, onSave, onDelete, task, featureId, initialStatus }) => {
//     const [editedTask, setEditedTask] = useState<Omit<Task, 'id' | 'comments' | 'assignee'>>({
//         title: '',
//         description: '', 
//         priority: 'Medium', 
//         status: initialStatus,
//         dueDate: undefined
//     });

//     useEffect(() => {
//         if (task) {
//             const { id, comments, assignee, ...rest } = task;
//             setEditedTask(rest);
//         } else {
//             setEditedTask({
//                 title: '',
//                 description: '', 
//                 priority: 'Medium', 
//                 status: initialStatus,
//                 dueDate: undefined
//             });
//         }
//     }, [task, isOpen, initialStatus]);

//     const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         setEditedTask(prev => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = (e: React.FormEvent) => {
//         e.preventDefault();
//         const finalTask: Task = {
//             id: task?.id || `${Date.now()}`,
//             comments: task?.comments || [],
//             assignee: task?.assignee || { name: 'Unassigned', avatar: '/default-avatar.png' },
//             ...editedTask,
//         };
//         onSave(finalTask, featureId);
//     };
    
//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
//             <div className="bg-white rounded-xl shadow-xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
//                 <form onSubmit={handleSubmit}>
//                      <header className="flex justify-between items-center p-5 border-b border-gray-200">
//                         <h2 className="text-xl font-bold text-gray-900">{task ? 'Edit Task' : 'Add New Task'}</h2>
//                         <button type="button" onClick={onClose} className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600">
//                             <XIcon />
//                         </button>
//                     </header>
//                     <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Task Title</label>
//                             <input 
//                                 name="title" 
//                                 value={editedTask.title} 
//                                 onChange={handleChange} 
//                                 placeholder="Enter task title" 
//                                 required 
//                                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-lg font-semibold" 
//                             />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
//                             <textarea 
//                                 name="description" 
//                                 value={editedTask.description} 
//                                 onChange={handleChange} 
//                                 placeholder="Add a description..." 
//                                 rows={4} 
//                                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
//                             />
//                         </div>
//                         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                                 <select name="status" value={editedTask.status} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
//                                     {columns.map(col => <option key={col} value={col}>{col}</option>)}
//                                 </select>
//                             </div>
//                              <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
//                                 <select name="priority" value={editedTask.priority} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
//                                     {priorities.map(p => <option key={p} value={p}>{p}</option>)}
//                                 </select>
//                             </div>
//                              <div>
//                                 <label className="block text-sm font-medium text-gray-700 mb-1">Due Date</label>
//                                 <input 
//                                     type="date" 
//                                     name="dueDate" 
//                                     value={editedTask.dueDate || ''} 
//                                     onChange={handleChange} 
//                                     className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                     <footer className="p-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center rounded-b-xl">
//                         <div>
//                             {task && (
//                                 <Button type="button" variant="danger" onClick={() => onDelete(task.id)}>
//                                     <TrashIcon /> Delete
//                                 </Button>
//                             )}
//                         </div>
//                         <div className="flex gap-3">
//                             <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
//                             <Button type="submit">Save Task</Button>
//                         </div>
//                     </footer>
//                 </form>
//             </div>
//         </div>
//     );
// };

// interface AddFeatureModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     onSave: (title: string) => void;
// }

// const AddFeatureModal: React.FC<AddFeatureModalProps> = ({ isOpen, onClose, onSave }) => {
//     const [title, setTitle] = useState('');

//     const handleSubmit = (e: React.FormEvent) => {
//         e.preventDefault();
//         if (title.trim()) {
//             onSave(title.trim());
//             setTitle('');
//             onClose();
//         }
//     };

//     if (!isOpen) return null;
    
//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
//             <div className="bg-white rounded-xl shadow-xl w-full max-w-md" onClick={e => e.stopPropagation()}>
//                 <form onSubmit={handleSubmit}>
//                     <header className="flex justify-between items-center p-5 border-b">
//                         <h2 className="text-xl font-bold text-gray-900">Add New Feature</h2>
//                         <button type="button" onClick={onClose} className="p-1 rounded-full hover:bg-gray-100"><XIcon /></button>
//                     </header>
//                     <div className="p-6">
//                         <label htmlFor="featureTitle" className="block text-sm font-medium text-gray-700 mb-1">Feature Title</label>
//                         <input 
//                             id="featureTitle" 
//                             value={title} 
//                             onChange={e => setTitle(e.target.value)} 
//                             placeholder="e.g., User Authentication" 
//                             required 
//                             className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
//                         />
//                     </div>
//                     <footer className="p-4 bg-gray-50 border-t flex justify-end gap-3">
//                         <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
//                         <Button type="submit">Add Feature</Button>
//                     </footer>
//                 </form>
//             </div>
//         </div>
//     );
// };

// const KanbanBoardPage: React.FC = () => {
//     const [allProjects, setAllProjects] = useState<Project[]>([]);
//     const [currentProjectId, setCurrentProjectId] = useState<string>('');
//     const [isLoading, setIsLoading] = useState(true);
//     const [isLoadingFeatures, setIsLoadingFeatures] = useState(false);
//     const toast = useToast();
    
//  const [openFeatures, setOpenFeatures] = useState<Record<TaskStatus, string[]>>({
//   'To Do': [],
//   'In Progress': [],
//   'In Review': [],
//   'Done': [],
// });
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedPriority, setSelectedPriority] = useState<TaskPriority | 'All'>('All');
//     const [selectedFeature, setSelectedFeature] = useState<string | 'All'>('All');
//     const [dueDateFilter, setDueDateFilter] = useState<'All' | 'Overdue' | 'Due Today'>('All');
//     const [sortOrder, setSortOrder] = useState<'Default' | 'DueDate' | 'Priority'>('Default');

//     const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
//     const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
//     const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

//     const [loadingFeaturesTasks, setLoadingFeaturesTasks] = useState<Set<string>>(new Set());
//     const [featureTasksMap, setFeatureTasksMap] = useState<Map<string, Task[]>>(new Map());

//     const projectDropdownRef = useRef<HTMLDivElement>(null);
//     const filterDropdownRef = useRef<HTMLDivElement>(null);
//     const sortDropdownRef = useRef<HTMLDivElement>(null);

//     // Modal State
//     const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
//     const [taskToEdit, setTaskToEdit] = useState<Task | null>(null);
//     const [activeFeatureId, setActiveFeatureId] = useState('');
//     const [activeStatus, setActiveStatus] = useState<TaskStatus>('To Do');
//     const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);

//     // NEW STATE: Track if tasks have been loaded for each feature
//     const [tasksLoadedForFeatures, setTasksLoadedForFeatures] = useState<Set<string>>(new Set());

//     // Get trainee token from localStorage or auth context
//     const getTraineeToken = (): string => {
//         const token = localStorage.getItem('TraineeToken') || '';
//         console.log('Trainee Token:', token ? 'Found' : 'Not found');
//         return token;
//     };

//     // Fetch projects from API
//     const fetchProjects = async () => {
//         try {
//             setIsLoading(true);
//             const traineeToken = getTraineeToken();
            
//             if (!traineeToken) {
//                 toast.error('Trainee token not found. Please log in again.');
//                 return;
//             }

//             console.log('Fetching projects...');
//             const response = await getTraineeProjectsByToken(traineeToken);
//             console.log('Projects API Response:', response);
            
//             if (response.success && response.data) {
//                 const projects: Project[] = response.data.map((project: any) => ({
//                     id: project.TraineeProjectToken,
//                     title: project.title,
//                     description: project.description || '',
//                     owner: { name: 'Project Owner', avatar: '/default-avatar.png' },
//                     members: [],
//                     features: []
//                 }));
                
//                 setAllProjects(projects);
                
//                 if (projects.length > 0 && !currentProjectId) {
//                     console.log('Setting initial project:', projects[0].title);
//                     setCurrentProjectId(projects[0].id);
//                 }
//             } else {
//                 console.error('Failed to fetch projects:', response.message);
//                 toast.error(response.message || 'Failed to fetch projects');
//             }
//         } catch (error: any) {
//             console.error('Error fetching projects:', error);
//             toast.error(error.response?.data?.message || 'Failed to fetch projects');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Fetch features for current project
//     const fetchProjectFeatures = async (projectId: string) => {
//         try {
//             setIsLoadingFeatures(true);
//             const traineeToken = getTraineeToken();
            
//             if (!traineeToken) {
//                 toast.error('Trainee token not found');
//                 return;
//             }

//             console.log('Fetching project features for:', projectId);
//             const response = await getTraineeProjectFeatures(traineeToken, projectId);
//             console.log('Project Features API Response:', response);

//             if (response.success && response.data) {
//                 const { projectTitle, statuses } = response.data;
//                 console.log('Project Title:', projectTitle);
//                 console.log('Statuses:', statuses);
                
//                 // Create a map to store features with their tasks organized by status
//                 const featureMap = new Map();
                
//                 // First pass: collect all unique features
//                 statuses.forEach((statusGroup: any) => {
//                     statusGroup.features.forEach((apiFeature: any) => {
//                         if (!featureMap.has(apiFeature.TraineeProjectFeatureToken)) {
//                             featureMap.set(apiFeature.TraineeProjectFeatureToken, {
//                                 id: apiFeature.TraineeProjectFeatureToken,
//                                 title: apiFeature.title,
//                                 tasks: [] // Will be populated with actual tasks later
//                             });
//                         }
//                     });
//                 });

//                 // Convert Map to array of features
//                 const features: Feature[] = Array.from(featureMap.values());
//                 console.log('Processed Features:', features);

//                 // Update the project with features
//                 setAllProjects(prev => prev.map(p => 
//                     p.id === projectId 
//                     ? { ...p, title: projectTitle, features } 
//                     : p
//                 ));

//                 // Open all features by default
//               setOpenFeatures({
//   'To Do': [],
//   'In Progress': [],
//   'In Review': [],
//   'Done': [],
// });

//                 // Clear previous task data
//                 setFeatureTasksMap(new Map());
//                 setTasksLoadedForFeatures(new Set());

//                 // FIX: Auto-load tasks for all features immediately
//                 if (features.length > 0) {
//                     console.log('Auto-loading tasks for all features immediately');
                    
//                     // Load tasks for all features immediately without waiting for user click
//                     features.forEach(feature => {
//                         fetchAllFeatureTasks(feature.id);
//                     });
//                 }
//             } else {
//                 console.error('Failed to fetch project features:', response.message);
//                 toast.error(response.message || 'Failed to fetch project features');
//             }
//         } catch (error: any) {
//             console.error('Error fetching project features:', error);
//             console.error('Error details:', error.response?.data);
//             toast.error(error.response?.data?.message || 'Failed to fetch project features');
//         } finally {
//             setIsLoadingFeatures(false);
//         }
//     };

//     // Fetch tasks for a specific feature across all statuses
//     const fetchAllFeatureTasks = async (featureToken: string) => {
//         // Don't load tasks if they're already loading or already loaded
//         if (loadingFeaturesTasks.has(featureToken) || tasksLoadedForFeatures.has(featureToken)) {
//             return;
//         }

//         try {
//             setLoadingFeaturesTasks(prev => new Set(prev).add(featureToken));
            
//             const traineeToken = getTraineeToken();
//             if (!traineeToken) {
//                 toast.error('Trainee token not found');
//                 return;
//             }

//             console.log('Fetching tasks for feature:', featureToken);
            
//             // Call getTraineeFeatureTasks for all statuses
//             const statusPromises = columns.map(async (status) => {
//                 const statusCode = mapTaskStatusToApiCode(status);
                
//                 try {
//                     console.log(`Calling getTraineeFeatureTasks for status: ${status} (${statusCode})`);
//                     const response = await getTraineeFeatureTasks({
//                         TraineeProjectFeatureToken: featureToken,
//                         statusCode: statusCode
//                     });

//                     console.log(`Tasks API Response for ${status}:`, response);

//                     if (response.success && response.data && response.data.tasks) {
//                         console.log(`Found ${response.data.tasks.length} tasks for ${status}`);
//                         return response.data.tasks.map((apiTask: any) => ({
//                             id: apiTask.TraineeTaskToken,
//                             title: apiTask.title,
//                             description: apiTask.description || '',
//                             priority: apiTask.priorityLevel as TaskPriority,
//                             status: mapApiStatusToTaskStatus(apiTask.statusName),
//                             dueDate: apiTask.dueDate || undefined,
//                             comments: [],
//                             assignee: {
//                                 name: 'Unassigned',
//                                 avatar: '/default-avatar.png'
//                             }
//                         }));
//                     } else {
//                         console.log(`No tasks found for status ${status} or API failed`);
//                     }
//                 } catch (error) {
//                     console.error(`Error fetching tasks for status ${status}:`, error);
//                 }
//                 return [];
//             });

//             const statusResults = await Promise.all(statusPromises);
            
//             // Combine all tasks from all statuses
//             const allTasks = statusResults.flat();
            
//             // Update the feature tasks map
//             setFeatureTasksMap(prev => {
//                 const newMap = new Map(prev);
//                 newMap.set(featureToken, allTasks);
//                 return newMap;
//             });

//             // Mark this feature's tasks as loaded
//             setTasksLoadedForFeatures(prev => {
//                 const newSet = new Set(prev);
//                 newSet.add(featureToken);
//                 return newSet;
//             });
            
//             console.log(`Loaded ${allTasks.length} tasks for feature ${featureToken}`);
            
//         } catch (error: any) {
//             console.error('Error fetching all feature tasks:', error);
//             console.error('Error details:', error.response?.data);
//             toast.error('Failed to load tasks for feature');
//         } finally {
//             setLoadingFeaturesTasks(prev => {
//                 const newSet = new Set(prev);
//                 newSet.delete(featureToken);
//                 return newSet;
//             });
//         }
//     };

//     // Handle project change
//     const handleProjectChange = async (projectId: string) => {
//         console.log('Project changed to:', projectId);
//         setCurrentProjectId(projectId);
//         setIsProjectDropdownOpen(false);
        
//         // Reset states
//         // setOpenFeatures([]);
//         setFeatureTasksMap(new Map());
//         setTasksLoadedForFeatures(new Set());
//         setSearchTerm('');
//         setSelectedPriority('All');
//         setSelectedFeature('All');
//         setDueDateFilter('All');
//         setSortOrder('Default');
        
//         // Load features for the new project
//         await fetchProjectFeatures(projectId);
//     };

//     // Add new task via API
// // Add new task via API
// const handleAddTask = async (taskData: Task, featureId: string) => {
//     try {
//         const traineeToken = getTraineeToken();
//         if (!traineeToken) {
//             toast.error('Trainee token not found');
//             return;
//         }

//         const response = await addProjectTask({
//             traineeToken,
//             TraineeProjectFeatureToken: featureId,
//             title: taskData.title,
//             description: taskData.description,
//             priorityLevel: taskData.priority,
//             startDate: taskData.dueDate,
//             endDate: taskData.dueDate,
//             remarks: '',
//             orderIndex: 0
//         });

//         if (response.success) {
//             toast.success('Task added successfully!');
            
//             // Immediately update local state instead of waiting for refresh
//             const newTask: Task = {
//                 id: response.data?.TraineeTaskToken || `${Date.now()}`, // Use the ID from response if available
//                 title: taskData.title,
//                 description: taskData.description,
//                 priority: taskData.priority,
//                 status: taskData.status,
//                 dueDate: taskData.dueDate,
//                 comments: [],
//                 assignee: {
//                     name: 'Unassigned',
//                     avatar: '/default-avatar.png'
//                 }
//             };

//             // Update the feature tasks map with the new task
//             setFeatureTasksMap(prev => {
//                 const newMap = new Map(prev);
//                 const existingTasks = newMap.get(featureId) || [];
//                 newMap.set(featureId, [...existingTasks, newTask]);
//                 return newMap;
//             });

//             // Also refresh from API to ensure we have the complete data
//             await fetchAllFeatureTasks(featureId);
//         } else {
//             toast.error(response.message || 'Failed to add task');
//         }
//     } catch (error: any) {
//         console.error('Error adding task:', error);
//         toast.error(error.response?.data?.message || 'Failed to add task');
//     }
// };

//     // Update task status via API
//    const handleUpdateTaskStatus = async (taskId: string, newStatus: TaskStatus) => {
//   try {
//     const statusCode = mapTaskStatusToApiCode(newStatus);
    
//     const response = await updateTraineeTaskStatus(taskId, statusCode);

//     if (response.success) {
//       toast.success('Task status updated successfully!');
      
//       // Update local state immediately instead of waiting for refresh
//       setFeatureTasksMap(prev => {
//         const newMap = new Map(prev);
        
//         // Find and update the task in all features
//         newMap.forEach((tasks, featureId) => {
//           const updatedTasks = tasks.map(task => 
//             task.id === taskId ? { ...task, status: newStatus } : task
//           );
//           newMap.set(featureId, updatedTasks);
//         });
        
//         return newMap;
//       });
      
//     } else {
//       toast.error(response.message || 'Failed to update task status');
//     }
//   } catch (error: any) {
//     console.error('Error updating task status:', error);
//     toast.error(error.response?.data?.message || 'Failed to update task status');
//   }
// };

//     // Initial data load
//     useEffect(() => {
//         fetchProjects();
//     }, []);

//     // Load features when project changes
//     useEffect(() => {
//         if (currentProjectId) {
//             console.log('Current project ID changed:', currentProjectId);
//             fetchProjectFeatures(currentProjectId);
//         }
//     }, [currentProjectId]);

//     const currentProject = useMemo(() => {
//         const project = allProjects.find(p => p.id === currentProjectId);
//         console.log('Current Project:', project);
//         return project;
//     }, [allProjects, currentProjectId]);

//     // Close dropdowns when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event: MouseEvent) => {
//             if (projectDropdownRef.current && !projectDropdownRef.current.contains(event.target as Node)) {
//                 setIsProjectDropdownOpen(false);
//             }
//             if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target as Node)) {
//                 setIsFilterDropdownOpen(false);
//             }
//             if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target as Node)) {
//                 setIsSortDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     // Get tasks for display - combine feature tasks with proper status filtering
//     const getTasksForDisplay = (featureId: string, status: TaskStatus) => {
//         const allTasks = featureTasksMap.get(featureId) || [];
//         const filteredTasks = allTasks.filter(task => task.status === status);
//         console.log(`Tasks for ${featureId} in ${status}:`, filteredTasks.length);
//         return filteredTasks;
//     };

//     const filteredAndSortedFeatures = useMemo(() => {
//         if (!currentProject) {
//             console.log('No current project');
//             return [];
//         }

//         let features = currentProject.features;
//         console.log('All features:', features);

//         // Filtering
//         if (selectedFeature !== 'All') {
//             features = features.filter(f => f.id === selectedFeature);
//             console.log('Filtered by feature:', features);
//         }

//         if (searchTerm.trim()) {
//             const lowercasedSearch = searchTerm.toLowerCase();
//             features = features.filter(feature => {
//                 // Check if feature title matches
//                 if (feature.title.toLowerCase().includes(lowercasedSearch)) {
//                     return true;
//                 }
                
//                 // Check if any tasks in any status match (using the feature tasks map)
//                 const allFeatureTasks = featureTasksMap.get(feature.id) || [];
//                 const hasMatchingTasks = allFeatureTasks.some(t => 
//                     t.title.toLowerCase().includes(lowercasedSearch) ||
//                     (t.description && t.description.toLowerCase().includes(lowercasedSearch))
//                 );
                
//                 return hasMatchingTasks;
//             });
//             console.log('Filtered by search:', features);
//         }

//         console.log('Final features to display:', features.length);
//         return features;
//     }, [currentProject, featureTasksMap, searchTerm, selectedFeature]);

//     const handleDragStart = (e: React.DragEvent<HTMLDivElement>, taskId: string) => {
//         e.dataTransfer.setData("taskId", taskId);
//     };

//     const handleDrop = async (e: React.DragEvent<HTMLDivElement>, newStatus: TaskStatus) => {
//         const taskId = e.dataTransfer.getData("taskId");
        
//         // Update via API first
//         await handleUpdateTaskStatus(taskId, newStatus);
//     };
    
//     const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();
    
// // Replace the toggleFeature function with this:
// const toggleFeature = (featureId: string, status: TaskStatus) => {
//   setOpenFeatures(prev => {
//     const currentStatusFeatures = prev[status] || [];
//     const isOpen = currentStatusFeatures.includes(featureId);
    
//     return {
//       ...prev,
//       [status]: isOpen 
//         ? currentStatusFeatures.filter(id => id !== featureId)
//         : [...currentStatusFeatures, featureId]
//     };
//   });
// };
    
//     const handleOpenAddTask = (featureId: string, status: TaskStatus) => {
//         setTaskToEdit(null);
//         setActiveFeatureId(featureId);
//         setActiveStatus(status);
//         setIsTaskModalOpen(true);
//     };

//     const handleOpenEditTask = (task: Task, featureId: string) => {
//         setTaskToEdit(task);
//         setActiveFeatureId(featureId);
//         setActiveStatus(task.status);
//         setIsTaskModalOpen(true);
//     };

//   const handleSaveTask = async (taskData: Task, featureId: string) => {
//     if (taskToEdit) {
//         // For existing tasks, update status via API
//         if (taskToEdit.status !== taskData.status) {
//             await handleUpdateTaskStatus(taskData.id, taskData.status);
//         } else {
//             // If only other fields changed, we'd need an update task API
//             toast.info('Task updates beyond status changes require additional API integration');
//         }
//     } else {
//         // Add new task via API
//         await handleAddTask(taskData, featureId);
//     }
    
//     // Close modal immediately after saving
//     setIsTaskModalOpen(false);
//     setTaskToEdit(null);
// };
    
//     const handleDeleteTask = (taskId: string) => {
//         toast.info('Task deletion requires backend API integration');
//         setIsTaskModalOpen(false);
//         setTaskToEdit(null);
//     };
    
//     const handleSaveFeature = (title: string) => {
//         toast.info('Adding features requires backend API integration');
//         setIsFeatureModalOpen(false);
//     };

//     const clearFilters = () => {
//         setSelectedPriority('All');
//         setSelectedFeature('All');
//         setDueDateFilter('All');
//         setIsFilterDropdownOpen(false);
//     };

//     if (isLoading) {
//         return (
//             <div>
//                 <PageTitle title="Kanban Board" />
//                 <Card className="p-8 text-center">
//                     <h3 className="text-xl font-semibold">Loading Projects...</h3>
//                     <p className="text-gray-500 mt-2">Please wait while we fetch your projects.</p>
//                 </Card>
//             </div>
//         );
//     }
    
//     if (!currentProject) {
//         return (
//              <div>
//                 <PageTitle title="Kanban Board" />
//                 <Card className="p-8 text-center">
//                     <h3 className="text-xl font-semibold">No Projects Found</h3>
//                     <p className="text-gray-500 mt-2">Could not find any projects to display.</p>
//                 </Card>
//             </div>
//         )
//     }

//     return (
//         <div className="flex flex-col h-full overflow-hidden">
//             <div className="flex-shrink-0">
//                 <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
//                     <div className="flex items-center gap-3">
//                         <div className="relative" ref={projectDropdownRef}>
//                             <button onClick={() => setIsProjectDropdownOpen(!isProjectDropdownOpen)} className="flex items-center gap-2 text-2xl font-bold text-gray-800 hover:text-primary transition-colors">
//                                 <span>{currentProject?.title || 'Select Project'}</span>
//                                 <ChevronDownIcon className={isProjectDropdownOpen ? 'rotate-180' : ''} />
//                             </button>
//                             {isProjectDropdownOpen && (
//                                 <div className="absolute top-full mt-2 w-72 bg-white rounded-lg shadow-xl py-2 z-20 border border-gray-200">
//                                     {allProjects.map(p => (
//                                         <button 
//                                             key={p.id} 
//                                             onClick={() => handleProjectChange(p.id)}
//                                             className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:font-semibold disabled:bg-red-50 disabled:text-red-600"
//                                             disabled={p.id === currentProjectId}
//                                         >
//                                             {p.title}
//                                         </button>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                         {isLoadingFeatures && (
//                             <div className="flex items-center gap-2 text-sm text-gray-500">
//                                 <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
//                                 Loading features...
//                             </div>
//                         )}
//                     </div>

//                     <div className="flex items-center gap-2">
//                          <Button onClick={() => setIsFeatureModalOpen(true)} size="sm"><PlusIcon/> Add Feature</Button>
//                     </div>
//                 </div>

//                 <Card className="p-3 mb-4 flex flex-wrap items-center gap-3">
//                     <div className="relative flex-grow sm:flex-grow-0 sm:w-64">
//                         <input type="text" placeholder="Search tasks..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full p-2 pl-10 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm" />
//                         <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><SearchIcon /></div>
//                     </div>
//                      <div className="relative" ref={filterDropdownRef}>
//                         <Button variant="outline" size="sm" onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}>
//                             <FilterIcon/> Filter <ChevronDownIcon className={isFilterDropdownOpen ? 'rotate-180' : ''}/>
//                         </Button>
//                         {isFilterDropdownOpen && (
//                             <div className="absolute top-full mt-2 w-64 bg-white rounded-lg shadow-xl p-4 z-20 border border-gray-200 space-y-4">
//                                 <div>
//                                     <label className="text-xs font-semibold text-gray-500">BY PRIORITY</label>
//                                     <select value={selectedPriority} onChange={e => setSelectedPriority(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
//                                         <option value="All">All Priorities</option>
//                                         {priorities.map(p => <option key={p} value={p}>{p}</option>)}
//                                     </select>
//                                 </div>
//                                  <div>
//                                     <label className="text-xs font-semibold text-gray-500">BY FEATURE</label>
//                                     <select value={selectedFeature} onChange={e => setSelectedFeature(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
//                                         <option value="All">All Features</option>
//                                         {currentProject?.features.map(f => <option key={f.id} value={f.id}>{f.title}</option>) || []}
//                                     </select>
//                                 </div>
//                                  <div>
//                                     <label className="text-xs font-semibold text-gray-500">BY DUE DATE</label>
//                                     <select value={dueDateFilter} onChange={e => setDueDateFilter(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
//                                         <option value="All">All Dates</option>
//                                         <option value="Overdue">Overdue</option>
//                                         <option value="Due Today">Due Today</option>
//                                     </select>
//                                 </div>
//                                 <Button variant="ghost" size="sm" className="w-full" onClick={clearFilters}>Clear Filters</Button>
//                             </div>
//                         )}
//                      </div>
//                       <div className="relative" ref={sortDropdownRef}>
//                         <Button variant="outline" size="sm" onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}>
//                             <SortIcon /> Sort <ChevronDownIcon className={isSortDropdownOpen ? 'rotate-180' : ''}/>
//                         </Button>
//                         {isSortDropdownOpen && (
//                             <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 z-20 border border-gray-200">
//                                 <button onClick={() => { setSortOrder('Default'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Default</button>
//                                 <button onClick={() => { setSortOrder('DueDate'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Sort by Due Date</button>
//                                 <button onClick={() => { setSortOrder('Priority'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Sort by Priority</button>
//                             </div>
//                         )}
//                     </div>
//                 </Card>
//             </div>

//             <div className="flex-1 overflow-x-auto pb-4">
//                 <div className="inline-grid grid-cols-4 gap-4 min-w-[1200px] h-full">
//                     {columns.map(status => (
//                         <div key={status} className={`flex flex-col rounded-lg border-t-4 ${columnColors[status]}`} onDrop={(e) => handleDrop(e, status)} onDragOver={handleDragOver}>
//                             <div className={`flex-shrink-0 p-3 font-bold uppercase text-sm ${columnHeaderColors[status]}`}>{status}</div>
//                             <div className="flex-1 p-2 bg-gray-100 rounded-b-lg overflow-y-auto space-y-3">
//                                {filteredAndSortedFeatures.map(feature => {
//   const tasksInStatus = getTasksForDisplay(feature.id, status);
                                    
//                                     // Apply additional filters to the tasks
//                                     let filteredTasks = tasksInStatus;
                                    
//                                     if (selectedPriority !== 'All') {
//                                         filteredTasks = filteredTasks.filter(t => t.priority === selectedPriority);
//                                     }

//                                     if (dueDateFilter !== 'All') {
//                                         const today = new Date();
//                                         const year = today.getFullYear();
//                                         const month = String(today.getMonth() + 1).padStart(2, '0');
//                                         const day = String(today.getDate()).padStart(2, '0');
//                                         const todayStr = `${year}-${month}-${day}`;

//                                         filteredTasks = filteredTasks.filter(t => {
//                                             if (!t.dueDate) return false;
//                                             if (dueDateFilter === 'Overdue') return t.dueDate < todayStr;
//                                             if (dueDateFilter === 'Due Today') return t.dueDate === todayStr;
//                                             return false;
//                                         });
//                                     }

//                                     // Apply sorting
//                                     const priorityOrder: Record<TaskPriority, number> = { 'High': 1, 'Medium': 2, 'Low': 3 };
                                    
//                                     filteredTasks = [...filteredTasks].sort((a, b) => {
//                                         if (sortOrder === 'Priority') {
//                                             return priorityOrder[a.priority] - priorityOrder[b.priority];
//                                         }
//                                         if (sortOrder === 'DueDate') {
//                                             if (!a.dueDate && !b.dueDate) return 0;
//                                             if (!a.dueDate) return 1;
//                                             if (!b.dueDate) return -1;
//                                             return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
//                                         }
//                                         return a.title.localeCompare(b.title);
//                                     });

//                                     // Skip rendering if no tasks and we have active filters
//                                     const hasActiveFilters = searchTerm.trim() !== '' || selectedPriority !== 'All' || selectedFeature !== 'All' || dueDateFilter !== 'All';
//                                     if (filteredTasks.length === 0 && hasActiveFilters) return null;

//                      const featureColumnKey = `${feature.id}-${status}`;
//   const isOpen = openFeatures[status]?.includes(feature.id) || false;
//   const isLoading = loadingFeaturesTasks.has(feature.id);

//   return (
//     <div key={featureColumnKey} className="bg-white/50 rounded-md"> {/* Use unique key */}
//       <button 
//         onClick={() => toggleFeature(feature.id, status)}
//         disabled={isLoading}
//         className="w-full flex justify-between items-center p-2 text-left font-semibold text-sm text-gray-700 hover:bg-gray-200/50 rounded-t-md disabled:opacity-50"
//       >
//         <span>{feature.title}</span>
//         <div className="flex items-center gap-2">
//           <span className="text-xs font-normal bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded-full">
//             {filteredTasks.length}
//           </span>
//           {isLoading ? (
//             <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
//           ) : (
//             <ChevronDownIcon className={isOpen ? 'rotate-180' : ''} />
//           )}
//         </div>
//       </button>
//                                             {isOpen && (
//                                                 <div className="p-2 border-t">
//                                                     {isLoading ? (
//             <div className="text-center py-4">
//               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto"></div>
//               <p className="text-gray-500 mt-2 text-sm">Loading tasks...</p>
//             </div>
//           ) : filteredTasks.length > 0 ? (
//             <>
//               {filteredTasks.map(task => (
//                 <TaskCardComponent 
//                   key={task.id} 
//                   task={task} 
//                   onDragStart={handleDragStart} 
//                   onClick={() => handleOpenEditTask(task, feature.id)}
//                 />
//               ))}
//             </>
//           ) : (
//             <div className="text-center py-4 text-gray-500 text-sm">
//               No tasks found for this feature in {status}.
//             </div>
//           )}
//           <Button variant="ghost" size="sm" className="w-full mt-1" onClick={() => handleOpenAddTask(feature.id, status)}>
//             <PlusIcon/> Add Task
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// })}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <TaskModal
//                 isOpen={isTaskModalOpen}
//                 onClose={() => setIsTaskModalOpen(false)}
//                 onSave={handleSaveTask}
//                 onDelete={handleDeleteTask}
//                 task={taskToEdit}
//                 featureId={activeFeatureId}
//                 initialStatus={activeStatus}
//             />
            
//             <AddFeatureModal 
//                 isOpen={isFeatureModalOpen}
//                 onClose={() => setIsFeatureModalOpen(false)}
//                 onSave={handleSaveFeature}
//             />
//         </div>
//     );
// };

// export default KanbanBoardPage;


import React, { useState, useMemo, useEffect, useRef } from 'react';
import { PageTitle, Button, Card } from '../components/common';
import { Project, Feature, Task, TaskStatus, TaskPriority } from '../types';
import { useToast } from '../components/Toaster';
import { 
  getTraineeProjectsByToken, 
  getTraineeProjectFeatures, 
  addProjectTask, 
  updateTraineeTaskStatus,
  getTraineeFeatureTasks,
  editProjectTask,
  deleteProjectTask 
} from '../services/api';

// Icons
const PlusIcon: React.FC<{className?: string}> = ({className = "w-4 h-4"}) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);

const CalendarIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 text-gray-500"}) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const XIcon: React.FC<{className?: string}> = ({className = "w-5 h-5"}) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const ChevronDownIcon: React.FC<{className?: string}> = ({className = ""}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`w-5 h-5 transition-transform ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const TrashIcon: React.FC<{className?: string}> = ({className = "h-4 w-4"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const SearchIcon: React.FC<{className?: string}> = ({className = "w-5 h-5 text-gray-400"}) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const FilterIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 mr-1.5"}) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
  </svg>
);

const SortIcon: React.FC<{className?: string}> = ({className = "w-4 h-4 mr-1.5"}) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9M3 12h9m-9 4h13m-3-3l-3 3m0 0l-3-3m3 3V4" />
  </svg>
);

const columns: TaskStatus[] = ['To Do', 'In Progress', 'In Review', 'Done'];
const priorities: TaskPriority[] = ['High', 'Medium', 'Low'];
const columnColors: Record<TaskStatus, string> = {
    'To Do': 'border-t-gray-400',
    'In Progress': 'border-t-orange-400',
    'In Review': 'border-t-purple-500',
    'Done': 'border-t-green-500',
};
const columnHeaderColors: Record<TaskStatus, string> = {
    'To Do': 'text-gray-700',
    'In Progress': 'text-orange-700',
    'In Review': 'text-purple-700',
    'Done': 'text-green-700',
};

// Helper function to map API status names to our TaskStatus
const mapApiStatusToTaskStatus = (statusName: string): TaskStatus => {
    const statusMap: Record<string, TaskStatus> = {
        'TO DO': 'To Do',
        'IN PROGRESS': 'In Progress',
        'IN REVIEW': 'In Review',
        'DONE': 'Done',
        'To Do': 'To Do',
        'In Progress': 'In Progress',
        'In Review': 'In Review',
        'Done': 'Done'
    };
    return statusMap[statusName] || 'To Do';
};

// Helper function to map our TaskStatus to API status codes
const mapTaskStatusToApiCode = (status: TaskStatus): string => {
    const statusMap: Record<TaskStatus, string> = {
        'To Do': 'TOD123',
        'In Progress': 'INP123',
        'In Review': 'INR123',
        'Done': 'DON123'
    };
    return statusMap[status] || 'TOD123';
};

interface PriorityBadgeProps {
    priority: TaskPriority;
}

const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
    const styles = {
        High: 'bg-red-100 text-red-700',
        Medium: 'bg-yellow-100 text-yellow-800',
        Low: 'bg-blue-100 text-blue-800',
    };
    return (
        <span className={`inline-block px-2 py-0.5 text-xs font-semibold rounded-full ${styles[priority]}`}>
            {priority}
        </span>
    );
};

interface StatusTagProps {
    status: TaskStatus;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
    const styles: Record<TaskStatus, string> = {
        'To Do': 'bg-gray-200 text-gray-800',
        'In Progress': 'bg-orange-200 text-orange-800',
        'In Review': 'bg-purple-200 text-purple-800',
        'Done': 'bg-green-200 text-green-800',
    };
    return (
        <span className={`px-2 py-1 text-xs font-medium rounded ${styles[status]}`}>
            {status}
        </span>
    );
};

interface TaskCardComponentProps {
    task: Task; 
    onDragStart: (e: React.DragEvent<HTMLDivElement>, taskId: string) => void;
    onEdit: (task: Task) => void;
}

const TaskCardComponent: React.FC<TaskCardComponentProps> = ({ task, onDragStart, onEdit }) => {
    const formatDate = (dateString?: string) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        return adjustedDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    const handleEditClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onEdit(task);
    }

    return (
        <div 
            draggable
            onDragStart={(e) => onDragStart(e, task.id)}
            className="bg-white p-3 mb-2 rounded-lg border border-gray-200 shadow-sm hover:shadow-md hover:border-primary transition-all duration-200 cursor-pointer group relative"
        >
            {/* Edit Button */}
            <button 
                onClick={handleEditClick}
                className="absolute top-2 right-2 p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-gray-400 hover:text-gray-600"
                title="Edit Task"
            >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
            </button>

            <div className="flex justify-between items-start">
                <div className="flex-1 pr-6">
                    <p className="font-semibold text-sm text-gray-800 group-hover:text-primary">{task.title}</p>
                    <div className="flex items-center justify-between gap-2 mt-2">
                        <StatusTag status={task.status} />
                        {formatDate(task.dueDate) && (
                            <div className="flex items-center text-xs text-gray-500">
                                <CalendarIcon />
                                <span className="ml-1">{formatDate(task.dueDate)}</span>
                            </div>
                        )}
                    </div>
                    <div className="flex justify-start items-center mt-3">
                        <PriorityBadge priority={task.priority} />
                    </div>
                    {/* <div className="flex items-center gap-2 mt-2">
                        <img 
                            src={task.assignee.avatar} 
                            alt={task.assignee.name}
                            className="w-6 h-6 rounded-full"
                        />
                        <span className="text-xs text-gray-600">{task.assignee.name}</span>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

// Delete Confirmation Modal
interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    taskTitle?: string;
    isDeleting?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    taskTitle,
    isDeleting = false 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md" onClick={e => e.stopPropagation()}>
                <div className="p-6 text-center">
                    {/* Warning Icon */}
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                    
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        Delete Task
                    </h3>
                    
                    <p className="text-sm text-gray-500 mb-6">
                        Are you sure you want to delete <span className="font-medium text-gray-900">"{taskTitle || 'this task'}"</span>? 
                        This action cannot be undone.
                    </p>

                    <div className="flex gap-3 justify-center">
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={onClose}
                            disabled={isDeleting}
                            className="px-6"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="button"
                            variant="danger"
                            onClick={onConfirm}
                            disabled={isDeleting}
                            className="px-6"
                        >
                            {isDeleting ? (
                                <>
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                    Deleting...
                                </>
                            ) : (
                                'Delete Task'
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface TaskModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (task: Task, featureId: string, isNew: boolean) => void;
    onDelete: (taskId: string, taskTitle: string) => void;
    task: Task | null;
    featureId: string;
    initialStatus: TaskStatus;
    isSaving?: boolean;
}

const TaskModal: React.FC<TaskModalProps> = ({ 
    isOpen, 
    onClose, 
    onSave, 
    onDelete, 
    task, 
    featureId, 
    initialStatus,
    isSaving = false 
}) => {
    const [editedTask, setEditedTask] = useState<Omit<Task, 'id' | 'comments' | 'assignee'>>({
        title: '',
        description: '', 
        priority: 'Medium', 
        status: initialStatus,
        dueDate: undefined
    });

    useEffect(() => {
        if (task) {
            const { id, comments, assignee, ...rest } = task;
            setEditedTask(rest);
        } else {
            setEditedTask({
                title: '',
                description: '', 
                priority: 'Medium', 
                status: initialStatus,
                dueDate: undefined
            });
        }
    }, [task, isOpen, initialStatus]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setEditedTask(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const finalTask: Task = {
            id: task?.id || `${Date.now()}`,
            comments: task?.comments || [],
            assignee: task?.assignee || { name: 'Unassigned', avatar: '/default-avatar.png' },
            ...editedTask,
        };
        onSave(finalTask, featureId, !task);
    };

    const handleDeleteClick = () => {
        if (task) {
            onDelete(task.id, task.title);
        }
    };
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                     <header className="flex justify-between items-center p-5 border-b border-gray-200">
                        <h2 className="text-xl font-bold text-gray-900">{task ? 'Edit Task' : 'Add New Task'}</h2>
                        <button type="button" onClick={onClose} className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600">
                            <XIcon />
                        </button>
                    </header>
                    <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Task Title</label>
                            <input 
                                name="title" 
                                value={editedTask.title} 
                                onChange={handleChange} 
                                placeholder="Enter task title" 
                                required 
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-lg font-semibold" 
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <textarea 
                                name="description" 
                                value={editedTask.description} 
                                onChange={handleChange} 
                                placeholder="Add a description..." 
                                rows={4} 
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
                            />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                <select name="status" value={editedTask.status} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
                                    {columns.map(col => <option key={col} value={col}>{col}</option>)}
                                </select>
                            </div>
                             <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                                <select name="priority" value={editedTask.priority} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
                                    {priorities.map(p => <option key={p} value={p}>{p}</option>)}
                                </select>
                            </div>
                             <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Due Date</label>
                                <input 
                                    type="date" 
                                    name="dueDate" 
                                    value={editedTask.dueDate || ''} 
                                    onChange={handleChange} 
                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
                                />
                            </div>
                        </div>
                    </div>
                    <footer className="p-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center rounded-b-xl">
                        <div>
                            {task && (
                                <Button 
                                    type="button" 
                                    variant="danger" 
                                    onClick={handleDeleteClick}
                                    disabled={isSaving}
                                >
                                    <TrashIcon /> Delete Task
                                </Button>
                            )}
                        </div>
                        <div className="flex gap-3">
                            <Button type="button" variant="secondary" onClick={onClose} disabled={isSaving}>
                                Cancel
                            </Button>
                            <Button type="submit" disabled={isSaving}>
                                {isSaving ? 'Saving...' : (task ? 'Update Task' : 'Save Task')}
                            </Button>
                        </div>
                    </footer>
                </form>
            </div>
        </div>
    );
};

interface AddFeatureModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (title: string) => void;
}

const AddFeatureModal: React.FC<AddFeatureModalProps> = ({ isOpen, onClose, onSave }) => {
    const [title, setTitle] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (title.trim()) {
            onSave(title.trim());
            setTitle('');
            onClose();
        }
    };

    if (!isOpen) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md" onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                    <header className="flex justify-between items-center p-5 border-b">
                        <h2 className="text-xl font-bold text-gray-900">Add New Feature</h2>
                        <button type="button" onClick={onClose} className="p-1 rounded-full hover:bg-gray-100"><XIcon /></button>
                    </header>
                    <div className="p-6">
                        <label htmlFor="featureTitle" className="block text-sm font-medium text-gray-700 mb-1">Feature Title</label>
                        <input 
                            id="featureTitle" 
                            value={title} 
                            onChange={e => setTitle(e.target.value)} 
                            placeholder="e.g., User Authentication" 
                            required 
                            className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" 
                        />
                    </div>
                    <footer className="p-4 bg-gray-50 border-t flex justify-end gap-3">
                        <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
                        <Button type="submit">Add Feature</Button>
                    </footer>
                </form>
            </div>
        </div>
    );
};

const KanbanBoardPage: React.FC = () => {
    const [allProjects, setAllProjects] = useState<Project[]>([]);
    const [currentProjectId, setCurrentProjectId] = useState<string>('');
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingFeatures, setIsLoadingFeatures] = useState(false);
    const toast = useToast();
    
    const [openFeatures, setOpenFeatures] = useState<Record<TaskStatus, string[]>>({
        'To Do': [],
        'In Progress': [],
        'In Review': [],
        'Done': [],
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPriority, setSelectedPriority] = useState<TaskPriority | 'All'>('All');
    const [selectedFeature, setSelectedFeature] = useState<string | 'All'>('All');
    const [dueDateFilter, setDueDateFilter] = useState<'All' | 'Overdue' | 'Due Today'>('All');
    const [sortOrder, setSortOrder] = useState<'Default' | 'DueDate' | 'Priority'>('Default');

    const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

    const [loadingFeaturesTasks, setLoadingFeaturesTasks] = useState<Set<string>>(new Set());
    const [featureTasksMap, setFeatureTasksMap] = useState<Map<string, Task[]>>(new Map());

    const projectDropdownRef = useRef<HTMLDivElement>(null);
    const filterDropdownRef = useRef<HTMLDivElement>(null);
    const sortDropdownRef = useRef<HTMLDivElement>(null);

    // Modal State
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [taskToEdit, setTaskToEdit] = useState<Task | null>(null);
    const [activeFeatureId, setActiveFeatureId] = useState('');
    const [activeStatus, setActiveStatus] = useState<TaskStatus>('To Do');
    const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);
    const [isSavingTask, setIsSavingTask] = useState(false);

    // Delete Confirmation State
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [taskToDelete, setTaskToDelete] = useState<{ id: string; title: string } | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);

    // NEW STATE: Track if tasks have been loaded for each feature
    const [tasksLoadedForFeatures, setTasksLoadedForFeatures] = useState<Set<string>>(new Set());

    // Get trainee token from localStorage or auth context
    const getTraineeToken = (): string => {
        const token = localStorage.getItem('TraineeToken') || '';
        return token;
    };

    // Fetch projects from API
    const fetchProjects = async () => {
        try {
            setIsLoading(true);
            const traineeToken = getTraineeToken();
            
            if (!traineeToken) {
                toast.error('Trainee token not found. Please log in again.');
                return;
            }

            const response = await getTraineeProjectsByToken(traineeToken);
            
            if (response.success && response.data) {
                const projects: Project[] = response.data.map((project: any) => ({
                    id: project.TraineeProjectToken,
                    title: project.title,
                    description: project.description || '',
                    owner: { name: 'Project Owner', avatar: '/default-avatar.png' },
                    members: [],
                    features: []
                }));
                
                setAllProjects(projects);
                
                if (projects.length > 0 && !currentProjectId) {
                    setCurrentProjectId(projects[0].id);
                }
            } else {
                toast.error(response.message || 'Failed to fetch projects');
            }
        } catch (error: any) {
            console.error('Error fetching projects:', error);
            toast.error(error.response?.data?.message || 'Failed to fetch projects');
        } finally {
            setIsLoading(false);
        }
    };

    // Fetch features for current project
    const fetchProjectFeatures = async (projectId: string) => {
        try {
            setIsLoadingFeatures(true);
            const traineeToken = getTraineeToken();
            
            if (!traineeToken) {
                toast.error('Trainee token not found');
                return;
            }

            const response = await getTraineeProjectFeatures(traineeToken, projectId);

            if (response.success && response.data) {
                const { projectTitle, statuses } = response.data;
                
                // Create a map to store features with their tasks organized by status
                const featureMap = new Map();
                
                // First pass: collect all unique features
                statuses.forEach((statusGroup: any) => {
                    statusGroup.features.forEach((apiFeature: any) => {
                        if (!featureMap.has(apiFeature.TraineeProjectFeatureToken)) {
                            featureMap.set(apiFeature.TraineeProjectFeatureToken, {
                                id: apiFeature.TraineeProjectFeatureToken,
                                title: apiFeature.title,
                                tasks: []
                            });
                        }
                    });
                });

                // Convert Map to array of features
                const features: Feature[] = Array.from(featureMap.values());

                // Update the project with features
                setAllProjects(prev => prev.map(p => 
                    p.id === projectId 
                    ? { ...p, title: projectTitle, features } 
                    : p
                ));

                // Clear previous task data
                setFeatureTasksMap(new Map());
                setTasksLoadedForFeatures(new Set());

                // Auto-load tasks for all features immediately
                if (features.length > 0) {
                    features.forEach(feature => {
                        fetchAllFeatureTasks(feature.id);
                    });
                }
            } else {
                toast.error(response.message || 'Failed to fetch project features');
            }
        } catch (error: any) {
            console.error('Error fetching project features:', error);
            toast.error(error.response?.data?.message || 'Failed to fetch project features');
        } finally {
            setIsLoadingFeatures(false);
        }
    };

    // Fetch tasks for a specific feature across all statuses
    const fetchAllFeatureTasks = async (featureToken: string) => {
        if (loadingFeaturesTasks.has(featureToken) || tasksLoadedForFeatures.has(featureToken)) {
            return;
        }

        try {
            setLoadingFeaturesTasks(prev => new Set(prev).add(featureToken));
            
            const traineeToken = getTraineeToken();
            if (!traineeToken) {
                toast.error('Trainee token not found');
                return;
            }

            // Call getTraineeFeatureTasks for all statuses
            const statusPromises = columns.map(async (status) => {
                const statusCode = mapTaskStatusToApiCode(status);
                
                try {
                    const response = await getTraineeFeatureTasks({
                        TraineeProjectFeatureToken: featureToken,
                        statusCode: statusCode
                    });

                    if (response.success && response.data && response.data.tasks) {
                        return response.data.tasks.map((apiTask: any) => ({
                            id: apiTask.TraineeTaskToken,
                            title: apiTask.title,
                            description: apiTask.description || '',
                            priority: apiTask.priorityLevel as TaskPriority,
                            status: mapApiStatusToTaskStatus(apiTask.statusName),
                            dueDate: apiTask.dueDate || undefined,
                            comments: [],
                            assignee: {
                                name: 'Unassigned',
                                avatar: '/default-avatar.png'
                            }
                        }));
                    }
                } catch (error) {
                    console.error(`Error fetching tasks for status ${status}:`, error);
                }
                return [];
            });

            const statusResults = await Promise.all(statusPromises);
            
            // Combine all tasks from all statuses
            const allTasks = statusResults.flat();
            
            // Update the feature tasks map
            setFeatureTasksMap(prev => {
                const newMap = new Map(prev);
                newMap.set(featureToken, allTasks);
                return newMap;
            });

            // Mark this feature's tasks as loaded
            setTasksLoadedForFeatures(prev => {
                const newSet = new Set(prev);
                newSet.add(featureToken);
                return newSet;
            });
            
        } catch (error: any) {
            console.error('Error fetching all feature tasks:', error);
            toast.error('Failed to load tasks for feature');
        } finally {
            setLoadingFeaturesTasks(prev => {
                const newSet = new Set(prev);
                newSet.delete(featureToken);
                return newSet;
            });
        }
    };

    // Handle project change
    const handleProjectChange = async (projectId: string) => {
        setCurrentProjectId(projectId);
        setIsProjectDropdownOpen(false);
        
        // Reset states
        setFeatureTasksMap(new Map());
        setTasksLoadedForFeatures(new Set());
        setSearchTerm('');
        setSelectedPriority('All');
        setSelectedFeature('All');
        setDueDateFilter('All');
        setSortOrder('Default');
        
        // Load features for the new project
        await fetchProjectFeatures(projectId);
    };

    // Add new task via API
    const handleAddTask = async (taskData: Task, featureId: string) => {
        try {
            const traineeToken = getTraineeToken();
            if (!traineeToken) {
                toast.error('Trainee token not found');
                return;
            }

            const response = await addProjectTask({
                traineeToken,
                TraineeProjectFeatureToken: featureId,
                title: taskData.title,
                description: taskData.description,
                priorityLevel: taskData.priority,
                startDate: taskData.dueDate,
                endDate: taskData.dueDate,
                remarks: '',
                orderIndex: 0
            });

            if (response.success) {
                toast.success('Task added successfully!');
                
                // Immediately update local state
                const newTask: Task = {
                    id: response.data?.TraineeTaskToken || `${Date.now()}`,
                    title: taskData.title,
                    description: taskData.description,
                    priority: taskData.priority,
                    status: taskData.status,
                    dueDate: taskData.dueDate,
                    comments: [],
                    assignee: {
                        name: 'Unassigned',
                        avatar: '/default-avatar.png'
                    }
                };

                // Update the feature tasks map with the new task
                setFeatureTasksMap(prev => {
                    const newMap = new Map(prev);
                    const existingTasks = newMap.get(featureId) || [];
                    newMap.set(featureId, [...existingTasks, newTask]);
                    return newMap;
                });

                // Also refresh from API to ensure we have the complete data
                await fetchAllFeatureTasks(featureId);
            } else {
                toast.error(response.message || 'Failed to add task');
            }
        } catch (error: any) {
            console.error('Error adding task:', error);
            toast.error(error.response?.data?.message || 'Failed to add task');
        }
    };

    // Update task via API
    const handleUpdateTask = async (taskData: Task, featureId: string) => {
        try {
            const traineeToken = getTraineeToken();
            if (!traineeToken) {
                toast.error('Trainee token not found');
                return;
            }

            const response = await editProjectTask({
                traineeToken,
                TraineeTaskToken: taskData.id,
                title: taskData.title,
                description: taskData.description,
                priorityLevel: taskData.priority,
                startDate: taskData.dueDate,
                endDate: taskData.dueDate,
                remarks: '',
                orderIndex: 0,
                TraineeTaskStatusId: mapTaskStatusToApiCode(taskData.status)
            });

            if (response.success) {
                toast.success('Task updated successfully!');
                
                // Update local state
                setFeatureTasksMap(prev => {
                    const newMap = new Map(prev);
                    const existingTasks = newMap.get(featureId) || [];
                    const updatedTasks = existingTasks.map(task => 
                        task.id === taskData.id ? { ...task, ...taskData } : task
                    );
                    newMap.set(featureId, updatedTasks);
                    return newMap;
                });

                // Refresh from API to ensure consistency
                await fetchAllFeatureTasks(featureId);
            } else {
                toast.error(response.message || 'Failed to update task');
            }
        } catch (error: any) {
            console.error('Error updating task:', error);
            toast.error(error.response?.data?.message || 'Failed to update task');
        }
    };

    // Delete task via API
    const handleDeleteTask = async (taskId: string) => {
        try {
            const traineeToken = getTraineeToken();
            if (!traineeToken) {
                toast.error('Trainee token not found');
                return;
            }

            const response = await deleteProjectTask(traineeToken, taskId);

            if (response.success) {
                toast.success('Task deleted successfully!');
                
                // Update local state by removing the task
                setFeatureTasksMap(prev => {
                    const newMap = new Map(prev);
                    newMap.forEach((tasks, featureId) => {
                        const filteredTasks = tasks.filter(task => task.id !== taskId);
                        newMap.set(featureId, filteredTasks);
                    });
                    return newMap;
                });

                setTaskToEdit(null);
            } else {
                toast.error(response.message || 'Failed to delete task');
            }
        } catch (error: any) {
            console.error('Error deleting task:', error);
            toast.error(error.response?.data?.message || 'Failed to delete task');
        }
    };

    // Update task status via API
    const handleUpdateTaskStatus = async (taskId: string, newStatus: TaskStatus) => {
        try {
            const statusCode = mapTaskStatusToApiCode(newStatus);
            
            const response = await updateTraineeTaskStatus(taskId, statusCode);

            if (response.success) {
                // Update local state immediately
                setFeatureTasksMap(prev => {
                    const newMap = new Map(prev);
                    newMap.forEach((tasks, featureId) => {
                        const updatedTasks = tasks.map(task => 
                            task.id === taskId ? { ...task, status: newStatus } : task
                        );
                        newMap.set(featureId, updatedTasks);
                    });
                    return newMap;
                });
            } else {
                toast.error(response.message || 'Failed to update task status');
            }
        } catch (error: any) {
            console.error('Error updating task status:', error);
            toast.error(error.response?.data?.message || 'Failed to update task status');
        }
    };

    // Save task (handles both create and update)
    const handleSaveTask = async (taskData: Task, featureId: string, isNew: boolean) => {
        setIsSavingTask(true);
        try {
            if (isNew) {
                await handleAddTask(taskData, featureId);
            } else {
                await handleUpdateTask(taskData, featureId);
            }
            
            setIsTaskModalOpen(false);
            setTaskToEdit(null);
        } finally {
            setIsSavingTask(false);
        }
    };

    // Handle delete button click - opens confirmation modal
    const handleDeleteClick = (taskId: string, taskTitle: string) => {
        setTaskToDelete({ id: taskId, title: taskTitle });
        setIsDeleteModalOpen(true);
        setIsTaskModalOpen(false); // Close the edit modal
    };

    // Handle confirmed delete
    const handleConfirmDelete = async () => {
        if (!taskToDelete) return;
        
        setIsDeleting(true);
        try {
            await handleDeleteTask(taskToDelete.id);
        } finally {
            setIsDeleting(false);
            setIsDeleteModalOpen(false);
            setTaskToDelete(null);
        }
    };

    // Handle cancel delete
    const handleCancelDelete = () => {
        setIsDeleteModalOpen(false);
        setTaskToDelete(null);
        // Reopen the edit modal if we were editing a task
        if (taskToEdit) {
            setIsTaskModalOpen(true);
        }
    };

    // Handle edit task
    const handleEditTask = (task: Task) => {
        setTaskToEdit(task);
        setActiveFeatureId(findFeatureIdByTaskId(task.id));
        setActiveStatus(task.status);
        setIsTaskModalOpen(true);
    };

    // Find feature ID by task ID
    const findFeatureIdByTaskId = (taskId: string): string => {
        let foundFeatureId = activeFeatureId;
        
        featureTasksMap.forEach((tasks, featureId) => {
            if (tasks.some(task => task.id === taskId)) {
                foundFeatureId = featureId;
            }
        });
        
        return foundFeatureId;
    };

    // Handle open add task
    const handleOpenAddTask = (featureId: string, status: TaskStatus) => {
        setTaskToEdit(null);
        setActiveFeatureId(featureId);
        setActiveStatus(status);
        setIsTaskModalOpen(true);
    };

    // Handle save feature
    const handleSaveFeature = (title: string) => {
        toast.info('Adding features requires backend API integration');
        setIsFeatureModalOpen(false);
    };

    const clearFilters = () => {
        setSelectedPriority('All');
        setSelectedFeature('All');
        setDueDateFilter('All');
        setIsFilterDropdownOpen(false);
    };

    // Initial data load
    useEffect(() => {
        fetchProjects();
    }, []);

    // Load features when project changes
    useEffect(() => {
        if (currentProjectId) {
            fetchProjectFeatures(currentProjectId);
        }
    }, [currentProjectId]);

    const currentProject = useMemo(() => {
        return allProjects.find(p => p.id === currentProjectId);
    }, [allProjects, currentProjectId]);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (projectDropdownRef.current && !projectDropdownRef.current.contains(event.target as Node)) {
                setIsProjectDropdownOpen(false);
            }
            if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target as Node)) {
                setIsFilterDropdownOpen(false);
            }
            if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target as Node)) {
                setIsSortDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Get tasks for display - combine feature tasks with proper status filtering
    const getTasksForDisplay = (featureId: string, status: TaskStatus) => {
        const allTasks = featureTasksMap.get(featureId) || [];
        return allTasks.filter(task => task.status === status);
    };

    const filteredAndSortedFeatures = useMemo(() => {
        if (!currentProject) {
            return [];
        }

        let features = currentProject.features;

        // Filtering
        if (selectedFeature !== 'All') {
            features = features.filter(f => f.id === selectedFeature);
        }

        if (searchTerm.trim()) {
            const lowercasedSearch = searchTerm.toLowerCase();
            features = features.filter(feature => {
                // Check if feature title matches
                if (feature.title.toLowerCase().includes(lowercasedSearch)) {
                    return true;
                }
                
                // Check if any tasks in any status match
                const allFeatureTasks = featureTasksMap.get(feature.id) || [];
                const hasMatchingTasks = allFeatureTasks.some(t => 
                    t.title.toLowerCase().includes(lowercasedSearch) ||
                    (t.description && t.description.toLowerCase().includes(lowercasedSearch))
                );
                
                return hasMatchingTasks;
            });
        }

        return features;
    }, [currentProject, featureTasksMap, searchTerm, selectedFeature]);

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>, taskId: string) => {
        e.dataTransfer.setData("taskId", taskId);
    };

    const handleDrop = async (e: React.DragEvent<HTMLDivElement>, newStatus: TaskStatus) => {
        const taskId = e.dataTransfer.getData("taskId");
        await handleUpdateTaskStatus(taskId, newStatus);
    };
    
    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();
    
    const toggleFeature = (featureId: string, status: TaskStatus) => {
        setOpenFeatures(prev => {
            const currentStatusFeatures = prev[status] || [];
            const isOpen = currentStatusFeatures.includes(featureId);
            
            return {
                ...prev,
                [status]: isOpen 
                    ? currentStatusFeatures.filter(id => id !== featureId)
                    : [...currentStatusFeatures, featureId]
            };
        });
    };

    if (isLoading) {
        return (
            <div>
                <PageTitle title="Kanban Board" />
                <Card className="p-8 text-center">
                    <h3 className="text-xl font-semibold">Loading Projects...</h3>
                    <p className="text-gray-500 mt-2">Please wait while we fetch your projects.</p>
                </Card>
            </div>
        );
    }
    
    if (!currentProject) {
        return (
             <div>
                <PageTitle title="Kanban Board" />
                <Card className="p-8 text-center">
                    <h3 className="text-xl font-semibold">No Projects Found</h3>
                    <p className="text-gray-500 mt-2">Could not find any projects to display.</p>
                </Card>
            </div>
        )
    }

    return (
        <div className="flex flex-col h-full overflow-hidden">
            <div className="flex-shrink-0">
                <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                    <div className="flex items-center gap-3">
                        <div className="relative" ref={projectDropdownRef}>
                            <button onClick={() => setIsProjectDropdownOpen(!isProjectDropdownOpen)} className="flex items-center gap-2 text-2xl font-bold text-gray-800 hover:text-primary transition-colors">
                                <span>{currentProject?.title || 'Select Project'}</span>
                                <ChevronDownIcon className={isProjectDropdownOpen ? 'rotate-180' : ''} />
                            </button>
                            {isProjectDropdownOpen && (
                                <div className="absolute top-full mt-2 w-72 bg-white rounded-lg shadow-xl py-2 z-20 border border-gray-200">
                                    {allProjects.map(p => (
                                        <button 
                                            key={p.id} 
                                            onClick={() => handleProjectChange(p.id)}
                                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:font-semibold disabled:bg-red-50 disabled:text-red-600"
                                            disabled={p.id === currentProjectId}
                                        >
                                            {p.title}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        {isLoadingFeatures && (
                            <div className="flex items-center gap-2 text-sm text-gray-500">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
                                Loading features...
                            </div>
                        )}
                    </div>

                    {/* <div className="flex items-center gap-2">
                         <Button onClick={() => setIsFeatureModalOpen(true)} size="sm"><PlusIcon/> Add Feature</Button>
                    </div> */}
                </div>

                <Card className="p-3 mb-4 flex flex-wrap items-center gap-3">
                    <div className="relative flex-grow sm:flex-grow-0 sm:w-64">
                        <input type="text" placeholder="Search tasks..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full p-2 pl-10 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm" />
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><SearchIcon /></div>
                    </div>
                     <div className="relative" ref={filterDropdownRef}>
                        <Button variant="outline" size="sm" onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}>
                            <FilterIcon/> Filter <ChevronDownIcon className={isFilterDropdownOpen ? 'rotate-180' : ''}/>
                        </Button>
                        {isFilterDropdownOpen && (
                            <div className="absolute top-full mt-2 w-64 bg-white rounded-lg shadow-xl p-4 z-20 border border-gray-200 space-y-4">
                                <div>
                                    <label className="text-xs font-semibold text-gray-500">BY PRIORITY</label>
                                    <select value={selectedPriority} onChange={e => setSelectedPriority(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
                                        <option value="All">All Priorities</option>
                                        {priorities.map(p => <option key={p} value={p}>{p}</option>)}
                                    </select>
                                </div>
                                 <div>
                                    <label className="text-xs font-semibold text-gray-500">BY FEATURE</label>
                                    <select value={selectedFeature} onChange={e => setSelectedFeature(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
                                        <option value="All">All Features</option>
                                        {currentProject?.features.map(f => <option key={f.id} value={f.id}>{f.title}</option>) || []}
                                    </select>
                                </div>
                                 <div>
                                    <label className="text-xs font-semibold text-gray-500">BY DUE DATE</label>
                                    <select value={dueDateFilter} onChange={e => setDueDateFilter(e.target.value as any)} className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary text-sm bg-white">
                                        <option value="All">All Dates</option>
                                        <option value="Overdue">Overdue</option>
                                        <option value="Due Today">Due Today</option>
                                    </select>
                                </div>
                                <Button variant="ghost" size="sm" className="w-full" onClick={clearFilters}>Clear Filters</Button>
                            </div>
                        )}
                     </div>
                      <div className="relative" ref={sortDropdownRef}>
                        <Button variant="outline" size="sm" onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}>
                            <SortIcon /> Sort <ChevronDownIcon className={isSortDropdownOpen ? 'rotate-180' : ''}/>
                        </Button>
                        {isSortDropdownOpen && (
                            <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 z-20 border border-gray-200">
                                <button onClick={() => { setSortOrder('Default'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Default</button>
                                <button onClick={() => { setSortOrder('DueDate'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Sort by Due Date</button>
                                <button onClick={() => { setSortOrder('Priority'); setIsSortDropdownOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Sort by Priority</button>
                            </div>
                        )}
                    </div>
                </Card>
            </div>

            <div className="flex-1 overflow-x-auto pb-4">
                <div className="inline-grid grid-cols-4 gap-4 min-w-[1200px] h-full">
                    {columns.map(status => (
                        <div key={status} className={`flex flex-col rounded-lg border-t-4 ${columnColors[status]}`} onDrop={(e) => handleDrop(e, status)} onDragOver={handleDragOver}>
                            <div className={`flex-shrink-0 p-3 font-bold uppercase text-sm ${columnHeaderColors[status]}`}>{status}</div>
                            <div className="flex-1 p-2 bg-gray-100 rounded-b-lg overflow-y-auto space-y-3">
                               {filteredAndSortedFeatures.map(feature => {
                                    const tasksInStatus = getTasksForDisplay(feature.id, status);
                                    
                                    // Apply additional filters to the tasks
                                    let filteredTasks = tasksInStatus;
                                    
                                    if (selectedPriority !== 'All') {
                                        filteredTasks = filteredTasks.filter(t => t.priority === selectedPriority);
                                    }

                                    if (dueDateFilter !== 'All') {
                                        const today = new Date();
                                        const year = today.getFullYear();
                                        const month = String(today.getMonth() + 1).padStart(2, '0');
                                        const day = String(today.getDate()).padStart(2, '0');
                                        const todayStr = `${year}-${month}-${day}`;

                                        filteredTasks = filteredTasks.filter(t => {
                                            if (!t.dueDate) return false;
                                            if (dueDateFilter === 'Overdue') return t.dueDate < todayStr;
                                            if (dueDateFilter === 'Due Today') return t.dueDate === todayStr;
                                            return false;
                                        });
                                    }

                                    // Apply sorting
                                    const priorityOrder: Record<TaskPriority, number> = { 'High': 1, 'Medium': 2, 'Low': 3 };
                                    
                                    filteredTasks = [...filteredTasks].sort((a, b) => {
                                        if (sortOrder === 'Priority') {
                                            return priorityOrder[a.priority] - priorityOrder[b.priority];
                                        }
                                        if (sortOrder === 'DueDate') {
                                            if (!a.dueDate && !b.dueDate) return 0;
                                            if (!a.dueDate) return 1;
                                            if (!b.dueDate) return -1;
                                            return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
                                        }
                                        return a.title.localeCompare(b.title);
                                    });

                                    // Skip rendering if no tasks and we have active filters
                                    const hasActiveFilters = searchTerm.trim() !== '' || selectedPriority !== 'All' || selectedFeature !== 'All' || dueDateFilter !== 'All';
                                    if (filteredTasks.length === 0 && hasActiveFilters) return null;

                                    const featureColumnKey = `${feature.id}-${status}`;
                                    const isOpen = openFeatures[status]?.includes(feature.id) || false;
                                    const isLoading = loadingFeaturesTasks.has(feature.id);

                                    return (
                                        <div key={featureColumnKey} className="bg-white/50 rounded-md">
                                            <button 
                                                onClick={() => toggleFeature(feature.id, status)}
                                                disabled={isLoading}
                                                className="w-full flex justify-between items-center p-2 text-left font-semibold text-sm text-gray-700 hover:bg-gray-200/50 rounded-t-md disabled:opacity-50"
                                            >
                                                <span>{feature.title}</span>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs font-normal bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded-full">
                                                        {filteredTasks.length}
                                                    </span>
                                                    {isLoading ? (
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
                                                    ) : (
                                                        <ChevronDownIcon className={isOpen ? 'rotate-180' : ''} />
                                                    )}
                                                </div>
                                            </button>
                                            {isOpen && (
                                                <div className="p-2 border-t">
                                                    {isLoading ? (
                                                        <div className="text-center py-4">
                                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto"></div>
                                                            <p className="text-gray-500 mt-2 text-sm">Loading tasks...</p>
                                                        </div>
                                                    ) : filteredTasks.length > 0 ? (
                                                        <>
                                                            {filteredTasks.map(task => (
                                                                <TaskCardComponent 
                                                                    key={task.id} 
                                                                    task={task} 
                                                                    onDragStart={handleDragStart} 
                                                                    onEdit={handleEditTask}
                                                                />
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <div className="text-center py-4 text-gray-500 text-sm">
                                                            No tasks found for this feature in {status}.
                                                        </div>
                                                    )}
                                                    <Button variant="ghost" size="sm" className="w-full mt-1" onClick={() => handleOpenAddTask(feature.id, status)}>
                                                        <PlusIcon/> Add Task
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Task Modal */}
            <TaskModal
                isOpen={isTaskModalOpen}
                onClose={() => setIsTaskModalOpen(false)}
                onSave={handleSaveTask}
                onDelete={handleDeleteClick}
                task={taskToEdit}
                featureId={activeFeatureId}
                initialStatus={activeStatus}
                isSaving={isSavingTask}
            />
            
            {/* Delete Confirmation Modal */}
            <DeleteConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                taskTitle={taskToDelete?.title}
                isDeleting={isDeleting}
            />
            
            {/* Add Feature Modal */}
            <AddFeatureModal 
                isOpen={isFeatureModalOpen}
                onClose={() => setIsFeatureModalOpen(false)}
                onSave={handleSaveFeature}
            />
        </div>
    );
};

export default KanbanBoardPage;